import { createSlice } from '@reduxjs/toolkit';

const dateDataReducer = createSlice({
    name: 'dateData',
    initialState: [] as any[],
    reducers: {
        // define your reducers here
        setDateData: (state, action) => {
            state.push(action.payload);
        },
        clearDateData: (state) => {
            state.length = 0;
        },


    },
});
export const { setDateData, clearDateData } = dateDataReducer.actions

export default dateDataReducer.reducer;
